<template>
  <HeaderPage>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card shadow">
          <div class="card-header text-center bg-primary text-white">
            <h3>Inscription</h3>
          </div>
          <div class="card-body">
            <form @submit.prevent="registerUser">
              <!-- Nom -->
              <div class="mb-3">
                <label for="nom" class="form-label">Nom</label>
                <input type="text" id="nom" v-model="form.nom" class="form-control" required />
              </div>
              <!-- Email -->
              <div class="mb-3">
                <label for="email" class="form-label">Email</label>
                <input type="email" id="email" v-model="form.email" class="form-control" required />
              </div>
              <!-- Mot de passe -->
              <div class="mb-3">
                <label for="motdepass" class="form-label">Mot de passe</label>
                <input type="password" id="motdepass" v-model="form.motdepass" class="form-control" required />
              </div>
              <!-- Confirmation du mot de passe -->
              <div class="mb-3">
                <label for="motdepass_confirmation" class="form-label">Confirmer le mot de passe</label>
                <input type="password" id="motdepass_confirmation" v-model="form.motdepass_confirmation" class="form-control" required />
              </div>
              <!-- Rôle -->
              <div class="mb-3">
                <label for="role" class="form-label">Rôle</label>
                <select id="role" v-model="form.role" class="form-select">
                  <option value="user">Utilisateur</option>
                  <option value="admin">Admin</option>
                </select>
              </div>
              <!-- Affichage des messages d'erreur ou de succès -->
              <div v-if="errorMessage" class="alert alert-danger">
                {{ errorMessage }}
              </div>
              <div v-if="successMessage" class="alert alert-success">
                {{ successMessage }}
              </div>
              <!-- Bouton de soumission -->
              <button type="submit" class="btn btn-primary w-100">S'inscrire</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</HeaderPage>
</template>

<script setup>
import { ref } from 'vue';
import axios from 'axios';
import HeaderPage from './components/HeaderPage.vue';


const API_URL = process.env.VUE_APP_API_URL;

const form = ref({
  nom: '',
  email: '',
  motdepass: '',
  motdepass_confirmation: '',
  role: 'user'
});

const errorMessage = ref('');
const successMessage = ref('');

async function registerUser() {
  // Réinitialiser les messages
  errorMessage.value = '';
  successMessage.value = '';
  
  try {
    // La requête envoie les données sous forme de paramètres dans l'URL (comme dans votre test Postman)
    const response = await axios.post(`${API_URL}/api/user/register`, null, {
      params: {
        nom: form.value.nom,
        email: form.value.email,
        motdepass: form.value.motdepass,
        motdepass_confirmation: form.value.motdepass_confirmation,
        role: form.value.role
      }
    });
    
    successMessage.value = response.data.message;
    // Réinitialiser le formulaire après inscription réussie
    form.value.nom = '';
    form.value.email = '';
    form.value.motdepass = '';
    form.value.motdepass_confirmation = '';
    form.value.role = 'user';
  } catch (error) {
    // Gestion des erreurs retournées par l'API
    if (error.response && error.response.data) {
      errorMessage.value = typeof error.response.data === 'object'
        ? Object.values(error.response.data).flat().join(' ')
        : error.response.data;
    } else {
      errorMessage.value = "Une erreur est survenue lors de l'inscription.";
    }
  }
}
</script>

<style scoped>
.card {
  margin-top: 20px;
}
</style>
